<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="glass-card pa-6 rounded-xl mb-0" dark>
        <div class="d-flex align-center mb-5">
          <v-icon color="success" large class="mr-3"> mdi-lock-reset </v-icon>

          <div>
            <div class="text-h6 font-weight-bold d-flex">
              Cambiar contraseña
            </div>
            <div class="caption">
              Actualizá la contraseña de acceso del usuario
            </div>
          </div>

          <v-spacer />

          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="usuario"
                prepend-inner-icon="mdi-account"
                label="Usuario"
                outlined
                dense
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="passNuevo"
                prepend-inner-icon="mdi-lock"
                @blur="$v.passNuevo.$touch()"
                label="Contraseña Nueva *"
                type="Password"
                outlined
                dense
                required
                maxlength="30"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="passNuevoRepetir"
                prepend-inner-icon="mdi-lock-plus"
                @blur="$v.passNuevoRepetir.$touch()"
                label="Repetir Contraseña Nueva *"
                type="Password"
                outlined
                dense
                required
                maxlength="30"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pa-0">
              <ul>
                <li
                  style="color: red; font-size: 13px; margin-bottom: 4px"
                  v-show="!$v.passNuevoRepetir.sameAs"
                >
                  Las contraseñas no coinciden
                </li>
                <li
                  style="color: red; font-size: 13px"
                  v-show="!$v.passNuevo.minLen"
                >
                  La nueva contraseña debe tener al menos 6 caracteres
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid || $v.$invalid"
            @click.stop="modificarContrasena"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    passNuevo: "",
    passNuevoRepetir: "",
  }),
  props: ["visible", "usuario"],
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarModels() {
      (this.usuario = ""), (this.passNuevo = ""), (this.passNuevoRepetir = "");
    },
    modificarContrasena() {
      this.$swal({
        title: "Modificar Contraseña",
        text: "¿Desea modificar la contraseña?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosUsuario = {
            usuario: this.usuario,
            passNuevo: this.passNuevo,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };

          let self = this;
          axios
            .get("/Usuario/CambiarPassUsuario?", {
              params: {
                usuario: datosUsuario.usuario,
                passNuevo: datosUsuario.passNuevo,
                idInstitucion: datosUsuario.idInstitucion,
              },
            })
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Contraseña modificada con éxito.",
                vm: self,
                timer: 2000,
              });
              self.$emit("close");
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "La contraseña no pudo ser modificada.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
  validations: {
    passNuevo: {
      required,
      minLen: minLength(6),
    },
    passNuevoRepetir: {
      //sameAs: sameAs('password')
      sameAs: sameAs((vm) => {
        return vm.passNuevo;
      }),
    },
  },
};
</script>
<style scoped>
.glass-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
}
</style>
